export const getApiBaseUrlExcludePath = (path: string): string => {
  return path.replace(import.meta.env.VITE_BASE_URL ?? '', '')
}
